import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
  { id:'goal', question:'What do you need help with?',
    options:['H1B Visa','Green Card (EB-2/EB-3)','H4 / EAD','AC21 Job Change','EB-2 NIW'] },
  { id:'status', question:'What is your current visa status?',
    options:['H-1B','F-1 / OPT','L-1','TN','Outside the US','Other'] },
  { id:'stage', question:'Where are you in the process?',
    options:['Just starting out','PERM in progress','I-140 filed','I-140 approved — waiting','Ready for I-485'] },
  { id:'country', question:'What is your country of birth?',
    options:['India','China','Mexico','Philippines','Brazil','Other'] },
];

export default function Wizard() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const navigate = useNavigate();

  function pick(val) {
    const next = { ...answers, [STEPS[step].id]: val };
    setAnswers(next);
    if (step < STEPS.length - 1) setStep(step + 1);
    else navigate('/perm-lookup');
  }

  const s = STEPS[step];
  const progress = (step / STEPS.length) * 100;

  return (
    <div style={{ minHeight:'80vh', display:'flex', alignItems:'center',
      justifyContent:'center', padding:'2rem' }}>
      <div style={{ width:'100%', maxWidth:'560px' }}>
        <div style={{ marginBottom:'2rem' }}>
          <div style={{ display:'flex', justifyContent:'space-between',
            fontSize:'12px', color:'#8A9BB0', marginBottom:'8px' }}>
            <span>Step {step + 1} of {STEPS.length}</span>
            <span>{Math.round(progress)}% complete</span>
          </div>
          <div style={{ background:'#E8ECF2', borderRadius:'100px', height:'4px' }}>
            <div style={{ background:'#1A9068', height:'4px', borderRadius:'100px',
              width:`${progress}%`, transition:'width 0.3s ease' }}></div>
          </div>
        </div>

        <h2 style={{ fontSize:'1.6rem', fontWeight:500, color:'#0B1F3A',
          marginBottom:'2rem', lineHeight:1.3 }}>{s.question}</h2>

        <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
          {s.options.map(opt => (
            <button key={opt} onClick={() => pick(opt)}
              style={{ background:'#fff', border:'1px solid #E8ECF2', borderRadius:'10px',
                padding:'1rem 1.25rem', textAlign:'left', fontSize:'15px', color:'#2C3E50',
                cursor:'pointer', fontFamily:'inherit', display:'flex',
                justifyContent:'space-between', alignItems:'center' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor='#1A9068'; e.currentTarget.style.background='#F7FFF9'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor='#E8ECF2'; e.currentTarget.style.background='#fff'; }}>
              {opt} <span style={{ color:'#1A9068' }}>→</span>
            </button>
          ))}
        </div>

        {step > 0 && (
          <button onClick={() => setStep(step - 1)}
            style={{ marginTop:'1.5rem', background:'none', border:'none',
              color:'#8A9BB0', fontSize:'13px', cursor:'pointer', fontFamily:'inherit' }}>
            ← Back
          </button>
        )}
      </div>
    </div>
  );
}